import React, { Component } from 'react';
import SubscribePage from '../../../container/subscribe/subscribePage';
import dropDownEvent from '../../../component/dropDownEvent';
import NoType from '../../../component/alert/noType';
import NoCountry from '../../../component/alert/noCountry';
import NoEmailLanguage from '../../../component/alert/noEmailLanguage';

class Subscription extends Component{
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    $("#activity, #project-context").show();
    dropDownEvent();
  }
  render() {
    return (
      <div style={{background: '#fff'}}>
        <div className="modal fade" id="hasSelectAll_modal">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title"> Alert </h4>
              </div>
              <div className="modal-body">
                <div className="alert alert-block">
                  <h4 className="alert-heading">All countries have been selected.</h4>
                  <p>You have selected all countries. If you want to select specific countries, please unselect the “All” countries setting.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SubscribePage manage={true} />
        <NoType />
        <NoCountry />
        <NoEmailLanguage />
      </div>
    );
  }
}

export default Subscription;


// WEBPACK FOOTER //
// ./src/container/dashboard/model/subscription.js